export default "__VITE_ASSET__DTZofO7o__"